<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}
.image_right {
  padding-bottom: 40px;
}




</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">Magiun Website</p>
      </b-col>
    </b-row>



    <b-row class='content'>
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Hybrid publication, web development, illustration, food writing</p>
        <p>
          Magiun is a magazine about everyday food. It publishes stories, poems, essays, recipes, photos and illustrations.</p>
        <p>
          The web version of the hybrid publications features all the content from the print versions, including text, illustration and other images.</p>
          <p>The website was developed and designed in BootstrapVue by Alice Strete. The pages for the second and third edition are designed by Simon Browne.</p>
          <p>This project was supported by CBK Rotterdam, Stichting Droom en Daad and Printroom Rotterdam.</p>




      </div>
      </b-col>
      <b-col md="4">

            <b-img class="img-fluid" src="media/magiunweb/2dn.png"></b-img>

<p></p>
            <b-img class="img-fluid" src="media/magiunweb/content.png"></b-img>
</b-col>
            <b-col md="4">

        <b-img class="img-fluid" src="media/magiunweb/3rd.png"></b-img>
<p></p>
<b-img class="img-fluid" src="media/magiunweb/table.png"></b-img>


      </b-col>
      <b-col md="8">

  <b-img class="img-fluid" src="media/magiunweb/each.png"></b-img>
<p></p>
<b-img class="img-fluid" src="media/magiunweb/paper.png"></b-img>

</b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'MagiunWeb',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
